import { Radio, Slider } from "antd";
import { range } from "lodash";
import { MdHelpOutline } from "react-icons/md";
import { useMediaQuery } from "react-responsive";

const options = { 1: "Faible", 2: "Modéré", 3: "Élevé", 4: "Très élevé" };

const NeedsContent = ({ categories, selectedValues, setSelectedValues, onClick }) => {
  const handleChange = (name, value) => {
    setSelectedValues((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="amellis__needs">
      <div className="amellis__slides">
        {categories.map((category) => (
          <div key={category.value}>
            <div className="--item">
              <div className="--head">
                <div className="--left">
                  <img src={category.icon} alt="" />
                  <div className="--content">
                    <span>{category.label}</span>
                    <small>
                      {category.description }
                    </small>
                  </div>
                </div>
                <div className="--right">
                  <MdHelpOutline size={20} onClick={onClick} />
                </div>
              </div>

              <Slider
                min={1}
                max={5}
                marks={options}
                value={selectedValues[category.value]}
                onChange={(value) => handleChange(category.value, value)}
                tooltip={{ open: false }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Needs = ({ categories = [], selectedValues, setSelectedValues, onClick }) => {

  return (
    <NeedsContent
      categories={categories}
      selectedValues={selectedValues}
      setSelectedValues={setSelectedValues}
      onClick={onClick}
    />
  )
};

export default Needs;
